import React, { useRef } from 'react';
import './login.css';
import logo from '../assets/logo.png';
import techglass from '../assets/techglass.png';
import { Link } from 'react-router-dom';
import { useGsapAnimations } from '../hooks/useGsapAnimations';

const Login = () => {
  const pageRef = useRef(null);

  useGsapAnimations(pageRef);

  return (
    <main className='login_page' ref={pageRef}>
      <section className='login_screen'>

        <img className='login_logo' src={logo} alt='Techne' data-gsap-intro />

        <img className='login_glass login_glass_left' src={techglass} alt='' data-gsap-intro data-gsap-float />
        <img className='login_glass login_glass_right' src={techglass} alt='' data-gsap-intro data-gsap-float />

        <div className='login_panel' data-gsap-intro>
          <div className='login_box' data-gsap-stagger="children" data-gsap-start="top 96%">
            <h1>Welcome Back</h1>

            <label className="sr_only" htmlFor="login-email">Email address</label>
            <input id="login-email" type='email' placeholder='Email address' autoComplete="email" />

            <label className="sr_only" htmlFor="login-password">Password</label>
            <input id="login-password" type='password' placeholder='Password' autoComplete="current-password" />

            <Link className='btnstyle2' to="/home">
              Log In
            </Link>
          </div>
        </div>

      </section>
    </main>
  );
};

export default Login;
